// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"7181e1ab","190":"ba3d6428","527":"641a797c","705":"4a156369","726":"3f3bafb2","775":"1d22f604","877":"fcf39694","897":"f6e51ff2"}[chunkId] + ".chunk.js";
};